import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { IdentityService } from '../../services/IdentityService';
import { LoaderComponent } from '../../controls/Loader';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';
import { connect } from 'react-redux';
import { IUserInfo } from '../../models/IUserInfo';
import Footer from './Footer';
import { ImageContainer } from './ImageContainer';
import { FormGroup } from '../../controls/Form/FormGroup';

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}

interface IProps extends RouteComponentProps<any> {
    UserInfo: IUserInfo | null
}

interface IState {
    Email: string,
    SubmitSuccess: boolean,
    SubmitError: boolean,
    LoaderVisible: boolean
}

class PasswordRecoveryComponent extends Component<IProps, IState> {
    private didSubmit = false;

    constructor(props) {
        super(props);

        this.state = {
            Email: '',
            SubmitSuccess: false,
            SubmitError: false,
            LoaderVisible: false
        }
    }

    public render() {
        const { LoaderVisible, SubmitSuccess, Email } = this.state;
        return (
            <div className="login-component route-component form-component">
                <div className="content-container">
                    <div className="content">
                        <LoaderComponent Visible={LoaderVisible} />
                        <div className="form-container">
                            <div className="form-container__wrapper">
                                <div className="kif-logo" />
                                <div className="header">
                                    <h3>Zresetuj hasło</h3>
                                    {
                                        SubmitSuccess ?
                                            <div className="sub-header">
                                                <span>Wysłaliśmy Ci na maila <b>{Email}</b> link aktywacyjny do zmiany hasła.</span>
                                                <br />
                                                <br />
                                                <br />
                                                <span>Sprawdź swoją pocztę i kliknij w link aby zresetować haslo.</span>
                                            </div>
                                            :
                                            (<span className="sub-header">Podaj nam swój e-mail, a wkrótce otrzymasz link oraz instrukcje do zmiany hasła.</span>)
                                    }
                                </div>
                                {
                                    SubmitSuccess ?
                                        <div className="submit-success-container">
                                            <div className="success-image" />
                                            <span>Nie otrzymałeś maila?</span>
                                            <span className="bottom-redirect"><a onClick={this.Submit}>Wyślij ponownie</a></span>
                                        </div>
                                        :
                                        (<form onSubmit={this.Submit}>
                                            <FormGroup
                                                Label="Email"
                                                Name="Email"
                                                OnChange={this.onInputChange}
                                                Value={Email}
                                                ErrorBlock="Błędny adres e-mail"
                                                ValidationState={this.GetEmailValidation}
                                            />
                                            <div className="form-buttons">
                                                <input type="submit" className="confirm-button-orange" value="Resetuj hasło" />
                                            </div>
                                            <span className="bottom-redirect"><a onClick={this.RedirectToLogin}>Wróć do logowania</a></span>
                                        </form>)
                                }
                            </div>
                        </div>
                        <ImageContainer />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }//end-of-render

    private GetEmailValidation = (): "success" | "warning" | "error" | undefined => {
        const { SubmitError } = this.state;
        if (this.didSubmit) {
            if (SubmitError) {
                return "error";
            } else {
                return "success";
            }
        } else {
            return undefined;
        }
    }

    private Submit = (evt) => {
        this.didSubmit = true;
        const { Email } = this.state;
        if (Email.length > 5 && Email.includes("@")) {
            let service = new IdentityService();
            this.setState({
                LoaderVisible: true
            });
            service.ResetPasswordRequest(Email, this.OnSubmitSuccess, this.OnSubmitError);
        } else {
            ShowStatusBar('Info', 'Sprawdź poprawność adresu email', DEFAULT_STATUS_TIMEOUT);
            this.setState({
                SubmitError: true
            });
        }
        evt.preventDefault();
    }

    private OnSubmitSuccess = (result) => {
        this.setState({
            SubmitSuccess: true,
            SubmitError: false,
            LoaderVisible: false
        });
    }

    private OnSubmitError = (error) => {
        if (error.response.data === "toconfirm") {
            ShowStatusBar('Error', 'Nie udało się zresetować hasła, konto nie zostało jeszcze aktywowane. Na podany adres email został wysłany link aktywacyjny.', DEFAULT_STATUS_TIMEOUT);
        }
        else {
            ShowStatusBar('Error', 'Nie udało się zresetować hasła. Sprawdź poprawność adresu email.', DEFAULT_STATUS_TIMEOUT);
        }

        this.setState({
            LoaderVisible: false,
            SubmitError: true
        });
    }

    private onInputChange = (event) => {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        if (event.target.value.length === 0) {
            this.setState({
                ...partialState,
                SubmitError: false
            })
        } else {
            this.setState(partialState);
        }

    }

    private RedirectToLogin = (evt) => {
        this.props.history.push('/');
    }

}

export default connect(MapState)(PasswordRecoveryComponent);


// WEBPACK FOOTER //
// ./src/components/Login/PasswordRecovery.tsx